import { useTranslations } from '~/composables/useTranslations';

export default {
    data() {
        return {
            currentViewLanguage: 'NL',
        }
    },
    methods: {
        // Centralized translation method using the composable
        getStaticTranslation(key) {
            const { translations } = useTranslations();
            if (!translations) {
                return key;
            }
            const langTranslations = translations[this.currentViewLanguage] || translations['NL'];
            return langTranslations[key] || key;
        },
        // Language change handling
        handleLanguageChange(event) {
            this.currentViewLanguage = event.detail;
            // Force Vue reactivity update
            this.$forceUpdate();
        },
        // Request current language from header
        requestCurrentLanguage() {
            const event = new CustomEvent('request-current-language');
            document.dispatchEvent(event);
        }
    },
    mounted() {
        // Check URL parameter for language override (highest priority)
        if (import.meta.client) {
            const urlParams = new URLSearchParams(window.location.search);
            const urlLg = urlParams.get('lg')?.toUpperCase();
            if (urlLg && ['FR', 'EN', 'NL'].includes(urlLg)) {
                this.currentViewLanguage = urlLg;
            } else {
                // Fall back to user's language if no URL parameter
                if (this.user?.language) {
                    this.currentViewLanguage = this.user.language;
                }
                if (this.project?.user?.language) {
                    this.currentViewLanguage = this.project.user.language;
                }
            }
        } else {
            // Server-side: use user's language
            if (this.user?.language) {
                this.currentViewLanguage = this.user.language;
            }
            if (this.project?.user?.language) {
                this.currentViewLanguage = this.project.user.language;
            }
        }

        // Listen for language changes
        if (import.meta.client) {
            document.addEventListener('language-changed', this.handleLanguageChange);

            // Request current language from header
            document.addEventListener('DOMContentLoaded', () => {
                this.requestCurrentLanguage();
            });

            // If DOM is already loaded, request immediately
            if (document.readyState === 'complete' || document.readyState === 'interactive') {
                this.requestCurrentLanguage();
            }
        }
    },
    beforeUnmount() {
        if (import.meta.client) {
            document.removeEventListener('language-changed', this.handleLanguageChange);
        }
    }
};